//获取列表
import {importFile, MainRequest} from '../../../Services/common';
import {download, removeSpaces, traverseTree} from '../../../Utils/common';
import {TagForm} from './Components/EditModal';
export enum TagType {
    Info = 'info',
    News = 'news',
}

export interface GetTagList {
    content?: string;
    typeId?: string;
}
export interface TagListProps {
    color?: string; //    一级分类颜色
    description?: string; //二级分类说明
    children?: TagListProps[]; //    二级标签列表
    typeName?: string; //    一级分类名称
    content?: string; //    二级分类名称
    id: string; //    一级分类id
    key: string;
    typeId?: string;
    label?: string;
    value?: string;
    selectable?: boolean;
    catalog: string;
}
export function getTagPage(data?: GetTagList) {
    return MainRequest.post<SuccessData<TagListProps[]>>(
        '/bigdata/queryTag',
        data,
    )
        .then(res => res.data.data)
        .then(res => {
            traverseTree({children: res}, (node: TagListProps) => {
                if (node?.typeId) {
                    node.key = `${node.id}-${TagForm.Tag}`;
                } else {
                    node.key = `${node.id}-${TagForm.Type}`;
                }
            });
            return res;
        })
        .then(res => {
            return {
                data: res,
                total: res.length,
            };
        });
}
export function getTagOptions() {
    return MainRequest.post<SuccessData<TagListProps[]>>(
        '/bigdata/queryTag',
        {},
    )
        .then(res => res.data.data)
        .then(res => {
            return res.map(item => {
                return {
                    label: item.typeName,
                    value: item.id,
                    ...item,
                };
            });
        });
}

export function getTags(data?: GetTagList) {
    let query = {};
    if (!data) {
        query = {
            content: '',
            typeId: '',
        };
    } else {
        query = data;
    }
    return MainRequest.post<SuccessData<TagListProps[]>>(
        '/bigdata/queryTag',
        query,
    )
        .then(res => res.data.data)
        .then(res => {
            traverseTree({children: res}, (node: TagListProps) => {
                node.label = node?.content || node?.typeName;
                node.value = node?.id;
                if (!node?.typeId) {
                    node.selectable = false;
                }
            });
            return res;
        });
}
//保存父级类型
export interface SaveTagType {
    id?: string;
    typeName?: string;
    color?: string;
    sort?: string;
}
export function saveTagType(data?: SaveTagType) {
    removeSpaces(data);
    return MainRequest.post('/bigdata/saveTagType', data);
}

//保存分类
export interface SaveTag {
    id?: string;
    content?: string; //    标签名称
    typeId?: string; //    所属一级分类id
    description?: string; //    标签说明
    catalog?: string;
}
export function saveTag(data?: SaveTag) {
    removeSpaces(data);
    return MainRequest.post('/bigdata/saveTag', data);
}

export type saveTagForm = SaveTag & SaveTagType;

//删除父级类型
export function deleteTagType(id: string[]) {
    return MainRequest.get(`/bigdata/deleteTagType/${id}`);
}

//删除分类
export function deleteTag(id: string[]) {
    return MainRequest.get(`/bigdata/delTag/${id}`);
}

//批量删除
export interface DeleteManyTag {
    typeIds: string[];
    tagIds: string[];
}
export function deleteBatch(data: DeleteManyTag) {
    return MainRequest.post(`/bigdata/delTagBatch`, data);
}

//下载一级分类导入模板
export function downloadTagTypeTemplate() {
    return download('/bigdata/downloadTagTypeTemplate', {method: 'get'});
}

//下载二级分类导入模板
export function downloadTagTemplate() {
    return download('/bigdata/downloadTagTemplate', {method: 'get'});
}

//导出标签
export function exportTag(params: GetTagList) {
    return download('/bigdata/exportTagList', {method: 'get', params});
}

//导入一级分类
export function importTagType(file: File) {
    return importFile('/bigdata/importTagType', file);
}

//导入二级分类
export function importTag(file: File) {
    return importFile('/bigdata/importTag', file);
}
